export default __webpack_public_path__ + "static/media/logo.1565eb6c.svg";